import { useRecoilState, useSetRecoilState } from 'recoil';
import query from '../useQueryWrapper';
import actions from 'api/analytics';
import {
  analyticsModels,
  currentRegionModel as currentRegionModelRecoil,
  currentAnalyticsModel as currentAnalyticsModelRecoil,
} from 'state/KubenAnalytics/analytics/models';

import { useRecoilValue } from 'recoil';
import { currentUser } from 'state/global/currentUser';

const useFetchAnalyticsModels = () => {
  const setAnalyticsModels = useSetRecoilState(analyticsModels);
  const [, setCurrentRegionModel] = useRecoilState(currentRegionModelRecoil);
  const [, setCurrentAnalyticModel] = useRecoilState(currentAnalyticsModelRecoil);
  const user = useRecoilValue(currentUser);

  return query.useQueryWrapper(
    'getAnalyticsModels',
    async () => {
      const analyticsModels = await actions.getAnalyticsModels();
      setAnalyticsModels(analyticsModels);
      const userRegionId = user?.defaultRegionId;
      let matchedModel = null;
      let matchedRegion = null;
      for (const model of analyticsModels) {
        const region = model.regions.find((r) => r.id === userRegionId);
        if (region) {
          matchedModel = model;
          matchedRegion = region;
          break;
        }
      }
      setCurrentRegionModel(matchedRegion);
      setCurrentAnalyticModel(matchedModel);

      return analyticsModels;
    },
    {
      refetchOnWindowFocus: false,
    },
  );
};

export default useFetchAnalyticsModels;
